import React, { Component } from 'react';
import { connect } from 'react-redux';
import { shape, object, string } from 'prop-types';
import { getURLParams } from '@widergy/web-utils/lib/browser';

import { actionCreators as authActions } from 'redux/authHandlers';
import { appConfig } from 'config/customization';
import { ROUTES } from 'constants/routes';
import AuthFormWrapper from 'app/components/AuthFormWrapper';

import { RESET_PASSWORD_TOKEN } from './constants';
import SignIn from './screens/SignIn';
import PasswordRecovery from './screens/PasswordRecovery';
import ChangePassword from './screens/ChangePassword';

const mapRouteToStepComponent = {
  [ROUTES.SIGN_IN]: SignIn,
  [ROUTES.SIGN_IN_PASSWORD_RECOVERY]: PasswordRecovery,
  [ROUTES.SIGN_IN_CHANGE_PASSWORD]: ChangePassword
};

class SignInContainer extends Component {
  handleChangePassword = values => {
    const params = getURLParams(
      this.props.location.search,
      RESET_PASSWORD_TOKEN,
      appConfig.PASSWORD_CHANGE_EXTERNAL_TOKEN
    );
    this.props.dispatch(
      authActions.recoveryPassword(
        values,
        params[RESET_PASSWORD_TOKEN],
        params[appConfig.PASSWORD_CHANGE_EXTERNAL_TOKEN]
      )
    );
  };

  handleNewPasswordRequest = values => {
    this.props.dispatch(authActions.newPasswordRequest(values));
  };

  handleSignIn = values => {
    this.props.dispatch(authActions.signIn(values));
  };

  childProps = () => {
    switch (this.props.location.pathname) {
      case ROUTES.SIGN_IN: {
        return { onSubmit: this.handleSignIn };
      }
      case ROUTES.SIGN_IN_PASSWORD_RECOVERY: {
        return { onSubmit: this.handleNewPasswordRequest };
      }
      case ROUTES.SIGN_IN_CHANGE_PASSWORD: {
        return { onSubmit: this.handleChangePassword, location: this.props.location };
      }
      default: {
        return {};
      }
    }
  };

  render() {
    const SignInComponent = mapRouteToStepComponent[this.props.location.pathname];
    return (
      <AuthFormWrapper>
        <SignInComponent {...this.childProps()} {...this.props.location.state} />
      </AuthFormWrapper>
    );
  }
}

SignInContainer.propTypes = {
  location: shape({
    pathname: string.isRequired,
    state: object,
    search: string
  })
};

export default connect()(SignInContainer);
